import { render } from "./LandingPageHeroSection.vue?vue&type=template&id=f8c2ad4a&scoped=true"
import script from "./LandingPageHeroSection.vue?vue&type=script&lang=js"
export * from "./LandingPageHeroSection.vue?vue&type=script&lang=js"

import "./LandingPageHeroSection.vue?vue&type=style&index=0&id=f8c2ad4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c2ad4a"]])

export default __exports__